import { render } from "./AttrCSS.vue?vue&type=template&id=362d08ea&scoped=true"
import script from "./AttrCSS.vue?vue&type=script&lang=js"
export * from "./AttrCSS.vue?vue&type=script&lang=js"

import "./AttrCSS.vue?vue&type=style&index=0&id=362d08ea&lang=css"
import "./AttrCSS.vue?vue&type=style&index=1&id=362d08ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-362d08ea"],['__file',"src/components/widgets/components_core/AttrCSS.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "362d08ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('362d08ea', __exports__)) {
    api.reload('362d08ea', __exports__)
  }
  
  module.hot.accept("./AttrCSS.vue?vue&type=template&id=362d08ea&scoped=true", () => {
    api.rerender('362d08ea', render)
  })

}


export default __exports__